import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {MoveLeft} from 'lucide-react';

const Breadcrumbs = ({
  items = [],
  mainText = '',
  mainTextPath = '',
  showBackButton = true,
}) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <nav
      aria-label="breadcrumb"
      className="flex items-center text-[10px] lg:text-sm text-gray-500"
    >
      {showBackButton && (
        <button className="flex items-center" onClick={handleGoBack}>
          <div
            className="p-1.5 border border-[#E4E7EC] rounded mr-3"
            aria-label="Go back"
          >
            <MoveLeft size={10} className="text-deepBlue" />
          </div>
          <span className="text-[#858DAA] font-medium mr-2">Go Back:</span>
        </button>
      )}

      {mainText && (
        <>
          {mainTextPath ? (
            <Link className="font-medium text-[#858DAA]" to={mainTextPath}>
              {mainText}
            </Link>
          ) : (
            <span className="font-medium text-[#858DAA]">{mainText}</span>
          )}
        </>
      )}

      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={item.path || item.to?.pathname || item.label}>
            {(index > 0 || mainText) && (
              <span className="mx-1.5 text-[#858DAA]">/</span>
            )}
            {isLast ? (
              <span className="font-medium text-deepBlue" aria-current="page">
                {item.label}
              </span>
            ) : (
              <Link
                className="font-medium text-[#858DAA]"
                to={{pathname: item.to || item.path, state: {...item?.state}}}
              >
                {item.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
